export const mdiMinus = 'M19 13H5v-2h14z';